import React from 'react';
import FormField from './form-field';

export default function SimpleInput(props) {
    const {
        input,
        label,
        type,
        meta,
        showError,
        disabled = false,
        placeholder,
        required
    } = props;
    return (
        <FormField label={label} meta={meta} showError={showError} required={required}>
            <input {...input} placeholder={placeholder} type={type} autoComplete="off" disabled={disabled}/>
        </FormField>

    );
}



// WEBPACK FOOTER //
// ./src/js/components/form/fields/input-field.jsx